import { ASDRatchets } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

export const getAsdRatchetsDescription = (value: ASDRatchets | undefined) => {
    if (!value || !value.inputDefinitions || !value.inputDefinitions.description) return 'n/a';
    return value.inputDefinitions.description;
};

export const getAsdRatchetsCalStrategy = (value: ASDRatchets | undefined) => {
    if (!value || !value.inputDefinitions || !value.inputDefinitions.calcStrategy) return 'n/a';
    return value.inputDefinitions.calcStrategy;
};

export const getAsdRatchetsNumerator = (value: ASDRatchets | undefined) => {
    if (!value || !value.inputDefinitions || !value.inputDefinitions.numerator) return 'n/a';
    return value.inputDefinitions.numerator;
};

export const getAsdRatchetsDenominator = (value: ASDRatchets | undefined) => {
    if (!value || !value.inputDefinitions || !value.inputDefinitions.denominator) return 'n/a';
    return value.inputDefinitions.denominator;
};
